/**
 * How a food log entry was created
 */
export var FoodLogSource;
(function (FoodLogSource) {
    FoodLogSource["FOOD_SCAN"] = "FOOD_SCAN";
    FoodLogSource["FOOD_LABEL"] = "FOOD_LABEL";
    FoodLogSource["MANUAL"] = "MANUAL";
    FoodLogSource["BARCODE"] = "BARCODE";
    FoodLogSource["DESCRIBE_TEXT"] = "DESCRIBE_TEXT";
})(FoodLogSource || (FoodLogSource = {}));
/**
 * User feedback on a vision scan result
 */
export var ScanFeedback;
(function (ScanFeedback) {
    ScanFeedback["POSITIVE"] = "POSITIVE";
    ScanFeedback["NEGATIVE"] = "NEGATIVE";
})(ScanFeedback || (ScanFeedback = {}));
/**
 * Source of an ingredient line within a food log
 */
export var FoodLogIngredientLineSource;
(function (FoodLogIngredientLineSource) {
    FoodLogIngredientLineSource["AI_SUGGESTED"] = "AI_SUGGESTED";
    FoodLogIngredientLineSource["CATALOG_USER_ADDED"] = "CATALOG_USER_ADDED";
    FoodLogIngredientLineSource["USER_INPUT"] = "USER_INPUT";
})(FoodLogIngredientLineSource || (FoodLogIngredientLineSource = {}));
/**
 * Source of catalog data (USDA = FoodData Central, CFS = Hong Kong Centre for Food Safety,
 * MANUAL = user-created / Excel import, AI_GENERATED = AI scan, WELLCOME = Wellcome seed/OCR import)
 */
export var CatalogSource;
(function (CatalogSource) {
    CatalogSource["USDA"] = "USDA";
    CatalogSource["CFS"] = "CFS";
    CatalogSource["MANUAL"] = "MANUAL";
    CatalogSource["AI_GENERATED"] = "AI_GENERATED";
    CatalogSource["WELLCOME"] = "WELLCOME";
})(CatalogSource || (CatalogSource = {}));
/**
 * Dish catalog entity type — controls portion handling and UI behavior
 */
export var DishType;
(function (DishType) {
    DishType["DISH"] = "DISH";
    DishType["DRINK"] = "DRINK";
    DishType["SNACK"] = "SNACK";
    DishType["PACKAGED"] = "PACKAGED";
})(DishType || (DishType = {}));
/**
 * Standardized dish categories for filtering/browsing.
 * Each maps to a DishType for portion logic.
 */
export const DISH_CATEGORIES = {
    [DishType.DRINK]: [
        'carbonated_drink',
        'tea',
        'coffee',
        'juice',
        'sports_drink',
        'milk_yogurt_drink',
    ],
    [DishType.DISH]: [
        'rice_dish',
        'noodle_dish',
        'soup',
        'western',
        'japanese',
        'dim_sum',
        'baby_food',
        'ready_to_eat',
        'salad',
        'seafood',
        'dessert',
    ],
    [DishType.SNACK]: [
        'chips_crisps',
        'biscuit_cracker',
        'candy_chocolate',
        'dried_fruit_nut',
    ],
    [DishType.PACKAGED]: [
        'cereal',
        'bread_bakery',
        'frozen_food',
        'condiment_sauce',
        'canned_food',
    ],
};
/** Flat list of all valid categories */
export const ALL_DISH_CATEGORIES = Object.values(DISH_CATEGORIES).flat();
/**
 * Standardized units for ingredient amounts
 */
export var IngredientAmountUnit;
(function (IngredientAmountUnit) {
    IngredientAmountUnit["GRAM"] = "GRAM";
    IngredientAmountUnit["ML"] = "ML";
    IngredientAmountUnit["CUP"] = "CUP";
    IngredientAmountUnit["TABLESPOON"] = "TABLESPOON";
    IngredientAmountUnit["TEASPOON"] = "TEASPOON";
    IngredientAmountUnit["PIECE"] = "PIECE";
    IngredientAmountUnit["SLICE"] = "SLICE";
    IngredientAmountUnit["OUNCE"] = "OUNCE";
    IngredientAmountUnit["SERVING"] = "SERVING";
})(IngredientAmountUnit || (IngredientAmountUnit = {}));
/**
 * Meal type for food log entries
 */
export var MealType;
(function (MealType) {
    MealType["BREAKFAST"] = "BREAKFAST";
    MealType["LUNCH"] = "LUNCH";
    MealType["DINNER"] = "DINNER";
    MealType["SNACK"] = "SNACK";
})(MealType || (MealType = {}));
